export default {
  name: 'ErrorUnavailablePage',
  data: function data() {
    return {
      citiesInfo: [{
        citySlug: 'msk',
        cityName: 'Москва',
        rawPhone: '+74951590841',
        formattedPhone: '+7 495 159-08-41'
      }, {
        citySlug: 'tmn',
        cityName: 'Тюмень',
        rawPhone: '+73452574706',
        formattedPhone: '+7 345 257-47-06'
      }, {
        citySlug: 'ekb',
        cityName: 'Екатеринбург',
        rawPhone: '+73433646084',
        formattedPhone: '+7 343 364-60-84'
      }, {
        citySlug: 'nsk',
        cityName: 'Новосибирск',
        rawPhone: '+73832478525',
        formattedPhone: '+7 383 247-85-25'
      }, {
        citySlug: 'spb',
        cityName: 'Санкт-Петербург',
        rawPhone: '+78123132559',
        formattedPhone: '+7 812 313-25-59'
      }]
    };
  }
};